export default __webpack_public_path__ + "static/media/KoziolPicture.83c9385f.jpg";